/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentInferencerPolymorphic } from './ConversationalAgentInferencerPolymorphic';
import {
  ConversationalAgentInferencerPolymorphicFromJSON,
  ConversationalAgentInferencerPolymorphicFromJSONTyped,
  ConversationalAgentInferencerPolymorphicToJSON,
} from './ConversationalAgentInferencerPolymorphic';
import type { ConversationalAgentDataset } from './ConversationalAgentDataset';
import {
  ConversationalAgentDatasetFromJSON,
  ConversationalAgentDatasetFromJSONTyped,
  ConversationalAgentDatasetToJSON,
} from './ConversationalAgentDataset';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';

/**
 *
 * @export
 * @interface ConversationalAgentGenerationInputs
 */
export interface ConversationalAgentGenerationInputs {
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof ConversationalAgentGenerationInputs
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentGenerationInputs
   */
  nSamples: number;
  /**
   *
   * @type {ConversationalAgentDataset}
   * @memberof ConversationalAgentGenerationInputs
   */
  readonly seedDataset: ConversationalAgentDataset;
  /**
   *
   * @type {ConversationalAgentInferencerPolymorphic}
   * @memberof ConversationalAgentGenerationInputs
   */
  readonly inferencer: ConversationalAgentInferencerPolymorphic;
}

/**
 * Check if a given object implements the ConversationalAgentGenerationInputs interface.
 */
export function instanceOfConversationalAgentGenerationInputs(
  value: object,
): value is ConversationalAgentGenerationInputs {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('nSamples' in value) || value['nSamples'] === undefined) return false;
  if (!('seedDataset' in value) || value['seedDataset'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  return true;
}

export function ConversationalAgentGenerationInputsFromJSON(json: any): ConversationalAgentGenerationInputs {
  return ConversationalAgentGenerationInputsFromJSONTyped(json, false);
}

export function ConversationalAgentGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    nSamples: json['n_samples'],
    seedDataset: ConversationalAgentDatasetFromJSON(json['seed_dataset']),
    inferencer: ConversationalAgentInferencerPolymorphicFromJSON(json['inferencer']),
  };
}

export function ConversationalAgentGenerationInputsToJSON(
  value?: Omit<ConversationalAgentGenerationInputs, 'id' | 'seedDataset' | 'inferencer'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    n_samples: value['nSamples'],
  };
}
